import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { CONTACT } from "../data/site";
import Reveal from "./Reveal";

export default function CTABand({
  title = "Ready to talk to someone?",
  body = "We'll verify your insurance and match you with the right therapist.",
  to = "/contact",
}) {
  return (
    <section className="section !pt-0" data-testid="cta-band">
      <Reveal y={40} className="container-site">
        <div className="gradient-pan relative overflow-hidden rounded-[2rem] px-7 py-12 md:px-14 md:py-16 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div aria-hidden="true" className="blob blob-a -top-24 -right-10 h-72 w-72 bg-white/15" />
          <div aria-hidden="true" className="blob blob-b -bottom-28 left-10 h-72 w-72 bg-[#a9bba2]/30" />
          <div className="relative max-w-xl">
            <h2 className="!text-white text-4xl md:text-5xl text-balance">{title}</h2>
            <p className="mt-3 text-white/85 leading-relaxed">{body}</p>
          </div>
          <div className="relative flex flex-col sm:flex-row gap-3">
            <Link to={to} className="btn !px-7 !py-4 bg-white text-[var(--ink)] hover:bg-[var(--sage-tint)] hover:shadow-[0_12px_30px_-12px_rgba(0,0,0,.35)]" data-testid="cta-band-primary">
              Book a Session <ArrowRight className="h-4 w-4" />
            </Link>
            <a href={CONTACT.phoneHref} className="btn !px-7 !py-4 border border-white/40 text-white hover:bg-white/10" data-testid="cta-band-phone">
              <Phone className="h-4 w-4" /> {CONTACT.phone}
            </a>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
